import { useMutation } from '@tanstack/react-query';

import { PricingPlanTierFormSchemaValues } from 'src/features/pricingPlan/utils/formSchema';
import { PricingPlanTier } from 'src/features/pricingPlan/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/pricing/pricing-plan/:planId/pricing-plan-tier/`;

interface DTO extends PricingPlanTierFormSchemaValues {
    planId: string;
    parkingId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ planId, parkingId, ...data }: DTO): Promise<PricingPlanTier> => {
    return axios.post(formatResourcePath(RESOURCE, { planId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreatePricingPlanTier };
